// React
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

// Redux
import { connect, useDispatch, useSelector } from 'react-redux';

// Assets
import { CDN_LINK } from '../assets/img';

// Components
import Loader from '../components/Shared/Utils/Loader';

// Action
import { getUserDetails } from '../actions/api/ApiStatisticsAction';
import getAllMasterData, {
  getPricingPlanMasterData
} from '../actions/MasterDataAction';

// Data
import idConstants from '../data/idConstants';
import { accessRoles } from '../data/appConstants';
import { getRegionCode } from '../utils/get-region-details';

// CSS
import './index.scss';

// react-pdf related js and css
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const FooterContainer = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const reduxStore = useSelector((state) => state);
  const [pdfUrl, setPdfUrl] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [numPages, setNumPages] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const content = props?.content;
  const headerContent = props?.content?.components?.header;
  const footerContent = props?.content?.components?.footer;
  const tenantConfig = props?.tenantConfig;
  const role = props?.user?.roles?.[0];

  const handleTabClick = (newActiveTab) => {
    setActiveTab(newActiveTab);
  };

  useEffect(() => {
    dispatch(getAllMasterData(idConstants.api.categoryId));
    dispatch(getPricingPlanMasterData(idConstants.api.categoryId));
  }, []);

  useEffect(() => {
    if (props?.accessToken) {
      dispatch(getUserDetails());
    }
  }, [props?.accessToken]);

  useEffect(() => {
    if (reduxStore?.loginReducer?.userDetails) {
      setCountryCode(reduxStore.loginReducer.userDetails.countryCode);
    }
  }, [reduxStore?.loginReducer?.userDetails]);

  useEffect(() => {
    if (!footerContent) return;
    const regionCode = getRegionCode();
    const valFromLink = window.location.pathname.split('/')[1];
    const baseURL = process.env.REACT_APP_AZURE_URL + `user-agreement-docs` + `/${regionCode}/`;
    document.body.style.overflow = 'hidden';
    const footerId = footerContent?.menu?.find((document) => document?.link?.split('/')[1] === valFromLink)?.id;
    setPdfUrl(baseURL + footerContent?.menu?.filter((document) => document.id === activeTab)[0]?.doc);
    handleTabClick(footerId);
    return function cleanup() {
      document.body.style.overflow = 'auto';
    };
  }, [countryCode, window.location.pathname, footerContent, activeTab]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const footerMenuItemClick = (document) => {
    handleTabClick(document.id);
    history.push(document.link);
  };

  const logoBrandNameClickHandler = () => {
    if (props?.accessToken && accessRoles.csm !== role) history.push('/dashboard');
    else if (accessRoles.csm === role) history.push('/dashboard/place-order');
    else history.push('/login');
  };

  return (
    <React.Fragment>
      {tenantConfig?.header?.ribbon && (
        <div
          style={{
            backgroundImage: `url(${CDN_LINK}/${headerContent?.images?.ribbon?.image})`
          }}
          className='bosch-strip'
        />
      )}
      <header className='header-name'>
        <div
          className='logo'
          onClick={logoBrandNameClickHandler}
          tabIndex={0}
          role='button'
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ')
              logoBrandNameClickHandler();
          }}
        >
          <img
            className='header-logo'
            src={`${CDN_LINK}/${headerContent?.images?.logo?.image}`}
            alt={headerContent?.images?.logo?.alt}
          />
        </div>
        <div
          className='brand-name'
          onClick={logoBrandNameClickHandler}
          tabIndex={0}
          role='button'
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ')
              logoBrandNameClickHandler();
          }}
        >
          {content?.name}
        </div>
      </header>
      <div className='tabs' role='tablist' aria-label='tabs'>
        <div className='tablist'>
          {footerContent?.menu?.map((document) => (
            <div
              className={`tab ${activeTab === document.id ? 'active' : ''}`}
              id='link'
              key={document.id}
              href={document.link}
              onClick={() => footerMenuItemClick(document)}
              tabIndex={0}
              role='button'
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ')
                  footerMenuItemClick(document);
              }}
            >
              {document.name}
            </div>
          ))}
        </div>
      </div>
      <div className='terms-of-use-modal-content-style'>
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Loader />}
          noData={footerContent?.no_data}
        >
          {Array.apply(null, Array(numPages))
            .map((_page, index) => index + 1)
            .map((page) => (
              <Page
                key={page.id}
                pageNumber={page}
                width={document.body.clientWidth}
                wrap={false}
                loading=''
              />
            ))}
        </Document>
      </div>
    </React.Fragment>
  );
};

FooterContainer.propTypes = {
  accessToken: PropTypes.string,
  content: PropTypes.object,
  user: PropTypes.object
};

const mapStateToProps = (redux_state) => ({
  accessToken: redux_state.loginReducer.accessToken,
  content: redux_state.ContentReducer.content,
  tenantConfig: redux_state.TenantConfigReducer.tenantConfig
});

export default connect(mapStateToProps, null)(FooterContainer);
